// Canonical game URLs use a trailing 2 (e.g. /games/menchbaz2).
// Backend API still stores games under legacy slugs (e.g. menchbaz),
// so the frontend maps new -> legacy when fetching, and redirects legacy -> new.

export const LEGACY_TO_NEW_GAME_SLUG = {
  menchbaz: "menchbaz2",
  mafianights: "mafianights2",
  zodiac: "zodiac2",
  quizbaz: "quizbaz2",
  ghasrsultan: "ghasrsultan2",
  rageofkings: "rageofkings2",
};

export const NEW_TO_LEGACY_GAME_SLUG = Object.fromEntries(
  Object.entries(LEGACY_TO_NEW_GAME_SLUG).map(([oldSlug, newSlug]) => [newSlug, oldSlug])
);

export function toCanonicalGameSlug(slug) {
  if (!slug) return slug;
  return LEGACY_TO_NEW_GAME_SLUG[slug] || slug;
}

export function toCanonicalGamePath(slug) {
  return `/games/${toCanonicalGameSlug(slug)}`;
}

// API still uses legacy slugs, so map the canonical slug back for fetching.
export function toApiGameSlug(gameId) {
  if (!gameId) return gameId;
  return NEW_TO_LEGACY_GAME_SLUG[gameId] || gameId;
}
